/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  mapGetters,
  mapState
} from 'vuex';
import {
  bus
} from '../../main';
import { VueEditor } from "vue2-editor";
export default {
  name: 'course-section-edit',
  components: {VueEditor},
  props: ['courseSectionID'],
  data() {
    return {
      name: '',
      description: '',
      id: '',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData:''
    }
  },
  computed: {
    ...mapGetters([
      'getsectionbycourseIDState',
      'getcourseSectionByIDDataState'
    ]),
    getCourseSectionDataByID() {
      this.$store.dispatch('get_course_section_fun', {
        id: this.courseSectionID
      }).then((res) => {
        this.name = this.$store.getters.getcourseSectionByIDDataState.data.name;
        this.description = this.$store.getters.getcourseSectionByIDDataState.data.description
        setTimeout(()=>{
          CKEDITOR.instances['updated_section_description'].setData(this.description);
        },100)
      }).catch((err) => {})
    }
  },
  mounted() {
    this.getCourseSectionDataByID,
    this.createEditor()
  },
  methods: {
    createEditor() {
      CKEDITOR.replace('updated_section_description',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['updated_section_description'].on('change', () => {
        var content1Length = CKEDITOR.instances['updated_section_description'].getData().replace(/<[^>]*>/gi, '').length;
        if(content1Length > 0){
          $('.custom_editor_for_option #updated_section_description').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #updated_section_description').removeClass('is-invalid')
          this.description = CKEDITOR.instances['updated_section_description'].getData()
        }else{
          $('.custom_editor_for_option #updated_section_description').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #updated_section_description').addClass('is-invalid')
          this.description = ''
        }
      })
    },
    getCourseDetailsAgain() {
      this.$store.dispatch('sectionbycourseId', {
        id: this.$route.params.id
      }).then((res) => {
        bus.$emit('hideEditSectionPopup', false)
      }).catch((err) => {})
    },
    validateSectionBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
            name: this.name,
            description: this.description
          }
          this.$store.dispatch('edit_course_section_fun', {
              data: {
                data: data,
                id: this.courseSectionID
              }
            })
            .then((res) => {
              this.getCourseDetailsAgain();
              toast.success(res.data.msg);
            })
            .catch((err) => {})
          return
        }
      });
    },

  }
}